import React from 'react';
import { SongStatusType } from 'types/song';
import { Center, Flex } from '@chakra-ui/react';
import { AudioActionButton } from '../Audio/AudioActionButton';
import { SongCover } from '../SongCover';

export interface SongCoverActionButtonProps {
  status: SongStatusType;
  isSongPlaying: boolean;
  isLoading?: boolean;
}

export const SongCoverActionButton: React.FC<SongCoverActionButtonProps> = ({
  status,
  isSongPlaying,
  isLoading,
}) => {
  return (
    <Center width={10} height={10} overflow="visible" role="group">
      <Flex
        role="button"
        position="relative"
        zIndex={1}
        transition="all .2s ease-in-out"
      >
        <SongCover
          size="medium"
          status={status}
          sx={{
            transition: 'opacity .2s ease-in-out',
            _groupHover: {
              opacity: 0.72,
            },
          }}
        />
        <AudioActionButton
          data-testid="songs-list-audio-play-button"
          size={24}
          playing={isSongPlaying}
          isLoading={isLoading}
          variant="cover"
          spinnerProps={{
            sx: {
              position: 'absolute',
              top: 2,
              left: 2,
              bg: 'transparent',
            },
          }}
          sx={{
            position: 'absolute',
            transform: 'translate(-50%, -50%)',
            top: '50%',
            left: '50%',
            _hover: {
              transform: 'translate(-50%, -50%) scale(1.02)',
            },
            _groupHover: {
              transform: 'translate(-50%, -50%) scale(1.02)',
            },
          }}
        />
      </Flex>
    </Center>
  );
};
